/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MonthlyClassTable.vue?vue&type=template&id=17ffdc0f&scoped=true&"
import script from "./MonthlyClassTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonthlyClassTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonthlyClassTable.vue?vue&type=style&index=0&id=17ffdc0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ffdc0f",
  null
  
)

export default component.exports